import type { TileListItem } from '@tilelist/domain/composition/TileListitem.ts';
import {
    COMPARISON_BANNER_POSITION,
    hasProductComparisonBanner,
} from '@tilelist/domain/feature-visibility/ComparisonBanner.ts';

export const BANNER_TARGET_POSITION = 6;

export function insertMASBannerTargets(tileListItems: TileListItem[]): TileListItem[] {
    const result: TileListItem[] = [];
    const hasPCB = hasProductComparisonBanner(tileListItems);
    const pcbIndex = COMPARISON_BANNER_POSITION - 1;
    let bannerSlot = 1;

    for (let i = 0; i < tileListItems.length; i++) {
        result.push(tileListItems[i]);

        const nextBannerPosition = calculateMASBannerPosition(bannerSlot, hasPCB, pcbIndex, i);
        const hasMoreItems = i + 1 < tileListItems.length;
        const shouldSkipBanner = i === pcbIndex && hasPCB;

        if (i + 1 === nextBannerPosition && hasMoreItems) {
            if (!shouldSkipBanner) {
                result.push(determineMASBannerSlotComponent(bannerSlot));
            }
            bannerSlot++;
        }
    }

    return result;
}

export function calculateMASBannerPosition(
    bannerSlot: number,
    hasPCB: boolean,
    pcbIndex: number,
    currentIndex: number,
): number {
    const basePosition = bannerSlot * BANNER_TARGET_POSITION;
    const pcbOffset = hasPCB && currentIndex > pcbIndex ? 1 : 0;
    return basePosition + pcbOffset;
}

export function determineMASBannerSlotComponent(bannerSlot: number): TileListItem {
    return { type: 'BT' as const, tilelistSlot: bannerSlot };
}
